

























import CategoriesApi from "@/services/CategoriesApi";
import { Category } from "@/api/lab-base-api-client";
import Vue from "vue";
import Component from "vue-class-component";
import AuthModule from "@/store/auth";

@Component
export default class CCategoryList extends Vue {
  // breadcrumbs設定配列
  private breadcrumbs = [
    {
      text: "category",
      disabled: true,
    },
  ];

  // アカウントの取得
  private get me() {
    return AuthModule.me;
  }

  // category一覧
  private categories: Category[] = [];

  // ページ読み込み時に実行
  private async mounted() {
    await this.fetch();
  }

  // category一覧を取得
  private async fetch() {
    const categoriesRes = await CategoriesApi.instance.getCategories();
    this.categories = categoriesRes.data.data.categories;

    this.categories.sort((a, b) => {
      if (a.id > b.id) {
        return 1;
      }
      return -1;
    });
  }
}
